<mdb-navbar [SideClass]="sideClass" [containerInside]="false">
  <mdb-navbar-brand>
    <a (click)="handleGoTo('/')" class="navbar-brand">
      <img alt="logo" height="36" [src]="logo" (error)="logo = './../../content/images/logos/demo/demo-navbar.png'" />
    </a>
  </mdb-navbar-brand>

  <div class="form-inline ml-auto">
    <jhi-bary-button
      data-id-cypress="btn-connect"
      size="sm"
      color="secondary"
      [label]="'components.disconnectedNavBar.buttons.login' | translate"
      (click)="handleLogin()"
      icon="user"
    ></jhi-bary-button>
  </div>
</mdb-navbar>
